import React, { useState } from 'react';
import { Nav, Collapse, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';

const getUserAndRole = () => {
    let roleId = sessionStorage.getItem('roleId') ? parseInt(sessionStorage.getItem('roleId')) : 0;
    let userName = sessionStorage.getItem('userName') || 'Usuario';
    return { roleId, userName };
};

function Sidebar() {
    const navigate = useNavigate();
    const location = useLocation();
    const { roleId, userName } = getUserAndRole();
    
    // Estados para controlar qué secciones están expandidas
    const [openSections, setOpenSections] = useState({
        objetos: true,
        reportes: false,
        usuarios: false,
        configuraciones: false
    });

    // Estado para controlar si el sidebar está expandido en móvil
    const [isMobileExpanded, setIsMobileExpanded] = useState(false);

    const handleLogout = () => {    
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userId');
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('roleId');          
        navigate('/login');
    };

    const toggleSection = (section) => {
        setOpenSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    };

    const toggleMobileSidebar = () => {
        setIsMobileExpanded(prev => !prev);
    };

    const isActive = (path) => location.pathname === path;

    const menuItems = [
        {
            id: 'objetos',
            title: 'Objetos',
            icon: 'bi-box-seam',
            roles: [1, 2, 3],
            items: [
                { name: 'Agregar Objeto', url: '/additem', icon: 'bi-plus-circle' },
                { name: 'Inventario', url: '/inventory', icon: 'bi-list-ul' }
            ]
        },
        {
            id: 'reportes',
            title: 'Reportes',
            icon: 'bi-graph-up',
            roles: [1, 2, 3],
            items: [
                { name: 'Ver Reportes', url: '/reports', icon: 'bi-file-earmark-text' }
            ]
        },
        {
            id: 'usuarios',
            title: 'Usuarios',
            icon: 'bi-people',
            roles: [2, 3],
            items: [
                { name: 'Lista de Usuarios', url: '/users', icon: 'bi-person-lines-fill' },
                { name: 'Agregar Usuario', url: '/adduser', icon: 'bi-person-plus' }
            ]
        },
        {
            id: 'configuraciones',
            title: 'Configuraciones',
            icon: 'bi-gear',
            roles: [1, 2, 3],
            items: [
                { name: 'Ubicaciones', url: '/locations', icon: 'bi-geo-alt' },
                { name: 'Categorías', url: '/itemCategories', icon: 'bi-tag' },
                { name: 'Subcategorías', url: '/ItemSubCategories', icon: 'bi-tags' }
            ]
        }
    ];

    const filteredMenu = menuItems.filter(section => section.roles.includes(roleId));

    return (
        <>
            {/* Botón toggle para móvil */}
            <button 
                className="mobile-toggle-btn"
                onClick={toggleMobileSidebar}
                aria-label="Toggle menu"
            >
                <i className={`bi ${isMobileExpanded ? 'bi-x-lg' : 'bi-list'}`}></i>
            </button>

            {/* Overlay para cerrar el sidebar en móvil */}
            {isMobileExpanded && (
                <div 
                    className="sidebar-overlay"
                    onClick={toggleMobileSidebar}
                ></div>
            )}

            <div className={`sidebar ${isMobileExpanded ? 'mobile-expanded' : ''}`}>
                <div className="sidebar-header">
                    <i className="bi bi-boxes"></i>
                    <h5>Mi Inventario</h5>
                </div>

                            <div className="sidebar-user">
                <div className="user-info">
                    <i className="bi bi-person-circle"></i>
                    <span className="user-name">{userName}</span>
                </div>
            </div>

            {/* Enlace a Inicio */}
            <div className="sidebar-home">
                <Nav.Link
                    onClick={() => {
                        navigate('/inventory');
                        setIsMobileExpanded(false);
                    }}
                    className={`sidebar-home-link ${isActive('/inventory') ? 'active' : ''}`}
                >
                    <i className="bi bi-house-door"></i>
                    <span>Inicio</span>
                </Nav.Link>
            </div>
            
            <Nav className="flex-column sidebar-nav">
                    {filteredMenu.map((section) => (
                        <div key={section.id} className="sidebar-section">
                            <div 
                                className="sidebar-section-header"
                                onClick={() => toggleSection(section.id)}
                            >
                                <div className="section-title">
                                    <i className={`bi ${section.icon}`}></i>
                                    <span>{section.title}</span>
                                </div>
                                <i className={`bi ${openSections[section.id] ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
                            </div>
                            
                            <Collapse in={openSections[section.id]}>
                                <div>
                                    {section.items.map((item) => (
                                        <Nav.Link
                                            key={item.url}
                                            onClick={() => {
                                                navigate(item.url);
                                                setIsMobileExpanded(false); // Cerrar sidebar al navegar en móvil
                                            }}
                                            className={`sidebar-item ${isActive(item.url) ? 'active' : ''}`}
                                        >
                                            <i className={`bi ${item.icon}`}></i>
                                            <span>{item.name}</span>
                                        </Nav.Link>
                                    ))}
                                </div>
                            </Collapse>
                        </div>
                    ))}
                </Nav>

                <div className="sidebar-footer">
                    <Button 
                        variant="outline-light" 
                        size="sm" 
                        className="logout-btn w-100"
                        onClick={handleLogout}
                    >
                        <i className="bi bi-box-arrow-right"></i>
                        <span>Cerrar sesión</span>
                    </Button>
                </div>
            </div>
        </>
    );
}

export default Sidebar;
